import {EnvService as BizkeytechEnvService} from "../../../@bizkeytech";


/**
 * @inheritDoc
 */
class EnvService extends BizkeytechEnvService {

    /**
     * The current version of the application.
     */
    public static version: string = process.env.REACT_APP_VERSION ?? "0.0.0";

    /**
     * Whether to bypass authentication or not.
     */
    public static bypassAuthentication: boolean = process.env.REACT_APP_BYPASS_AUTHENTICATION === 'true';

    /**
     * The name of the application for QueryBuilder and DataGrid services.
     */
    public static servicesApplicationName: string = process.env.REACT_APP_SERVICES_APPLICATION_NAME ?? "";

    /**
     * The website id of the crisp chat.
     */
    public static crispWebsiteId: string = process.env.REACT_APP_CRISP_WEBSITE_ID ?? "";
}

export default EnvService;
